import styled, { css } from "styled-components";

export enum PopupPlacement {
  bottom = "bottom",
  bottomLeft = "bottomLeft",
  bottomRight = "bottomRight",
  top = "top",
  topLeft = "topLeft",
  topRight = "topRight",
  right = "right",
  rightTop = "rightTop",
}

export type PlacementType = `${PopupPlacement}`;

export const placementMap = new Map([
  [
    PopupPlacement.bottom,
    css`
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 100%);
    `,
  ],
  [
    PopupPlacement.bottomLeft,
    css`
      bottom: 0;
      left: 0;
      transform: translate(0, 100%);
    `,
  ],
  [
    PopupPlacement.bottomRight,
    css`
      bottom: 0;
      right: 0;
      transform: translate(0, 100%);
    `,
  ],
  [
    PopupPlacement.top,
    css`
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);
    `,
  ],
  [
    PopupPlacement.topLeft,
    css`
      top: 0;
      left: 0;
      transform: translate(0, -100%);
    `,
  ],
  [
    PopupPlacement.topRight,
    css`
      top: 0;
      right: 0;
      transform: translate(0, -100%);
    `,
  ],
  [
    PopupPlacement.rightTop,
    css`
      top: 0;
      right: 0;
      transform: translate(100%, 0);
    `,
  ],
]);

export const getOffsetByPlacement = (
  placement: `${PopupPlacement}`,
  offsetX = "0px",
  offsetY = "0px",
  isTooltip = false
) => {
  const extraOffset = {
    y: "0px",
  };
  if (placement.includes("bottom") && isTooltip) {
    extraOffset.y = "5px";
  }
  const res = {
    [PopupPlacement.bottom]: css`
      transform: translate(
        calc(-50% + ${offsetX}),
        calc(100% + ${offsetY} + ${extraOffset.y})
      );
    `,
    [PopupPlacement.bottomLeft]: css`
      transform: translate(
        calc(0% + ${offsetX}),
        calc(100% + ${offsetY} + ${extraOffset.y})
      );
    `,
    [PopupPlacement.bottomRight]: css`
      transform: translate(
        calc(0% + ${offsetX}),
        calc(100% + ${offsetY} + ${extraOffset.y})
      );
    `,
    [PopupPlacement.top]: css`
      transform: translate(calc(-50% + ${offsetX}), calc(-100% + ${offsetY}));
    `,
    [PopupPlacement.topLeft]: css`
      transform: translate(calc(0px + ${offsetX}), calc(-100% + ${offsetY}));
    `,
    [PopupPlacement.topRight]: css`
      transform: translate(calc(0px + ${offsetX}), calc(-100% + ${offsetY}));
    `,
    [PopupPlacement.rightTop]: css`
      transform: translate(calc(100% + ${offsetX}), calc(0% + ${offsetY}));
    `,
    [PopupPlacement.right]: css`
      transform: translate(calc(100% + ${offsetX}), calc(0% + ${offsetY}));
    `,
  }[placement];
  return res;
};

export const getTooltipArrowPosition = (placement: PlacementType) => {
  const bottomStype = css`
    position: absolute;
    top: 0;
    transform: translate(0, -100%) rotate(180deg);
  `;
  const leftStyle = css`
    margin-left: 20px;
    align-self: flex-start;
  `;
  const rightStyle = css`
    margin-right: 20px;
    align-self: flex-end;
  `;
  return css`
    ${[
      PopupPlacement.bottom,
      PopupPlacement.bottomLeft,
      PopupPlacement.bottomRight,
    ].includes(placement) && bottomStype};
    ${[PopupPlacement.topLeft, PopupPlacement.bottomLeft].includes(placement) &&
    leftStyle};
    ${[PopupPlacement.topRight, PopupPlacement.bottomRight].includes(
      placement
    ) && rightStyle};
  `;
};

export function getPlacement({
  placement = PopupPlacement.bottom,
  basicLeft = 0,
  basicTop = 0,
  basicRight = 0,
  basicBottom = 0,
  dropdownContentWidth = 0,
}) {
  const referenceWidth = basicRight - basicLeft;
  const centerXOffset = (referenceWidth - dropdownContentWidth) / 2;
  const placementMap = new Map([
    [
      PopupPlacement.bottom,
      css`
        top: ${basicBottom}px;
        left: ${basicLeft + centerXOffset}px;
      `,
    ],
    [
      PopupPlacement.bottomLeft,
      css`
        top: ${basicBottom}px;
        left: ${basicLeft}px;
      `,
    ],
    [
      PopupPlacement.bottomRight,
      css`
        top: ${basicBottom}px;
        left: ${basicRight - dropdownContentWidth}px;
      `,
    ],
    [
      PopupPlacement.top,
      css`
        top: 0;
        left: 50%;
        transform: translate(-50%, -100%);
      `,
    ],
    [
      PopupPlacement.topLeft,
      css`
        top: 0;
        left: 0;
        transform: translate(0, -100%);
      `,
    ],
    [
      PopupPlacement.topRight,
      css`
        top: 0;
        right: 0;
        transform: translate(0, -100%);
      `,
    ],
    [
      PopupPlacement.rightTop,
      css`
        top: ${basicTop}px;
        left: ${basicRight}px;
      `,
    ],
  ]);
  return placementMap.get(placement);
}
